export default __webpack_public_path__ + "static/media/modal-edge-shape-2.1d01f6d6.png";